__turbopack_context__.v({
  "active": "NotifyModal-module-scss-module__-gq6pq__active",
  "card": "NotifyModal-module-scss-module__-gq6pq__card",
  "error": "NotifyModal-module-scss-module__-gq6pq__error",
  "formControlTextarea": "NotifyModal-module-scss-module__-gq6pq__formControlTextarea",
  "formWrap": "NotifyModal-module-scss-module__-gq6pq__formWrap",
  "inputDouble": "NotifyModal-module-scss-module__-gq6pq__inputDouble",
  "modalWrapper": "NotifyModal-module-scss-module__-gq6pq__modalWrapper",
  "privacyPolicy": "NotifyModal-module-scss-module__-gq6pq__privacyPolicy",
  "wrapper": "NotifyModal-module-scss-module__-gq6pq__wrapper",
});
